export const myTheme = {
    primary:"#8BD8BD",//dark for text
    secondary:"#243665",//light for bg or body
    fontFamily:"'Source Sans Pro', sans-serif",
    bodyRgba: "252,246, 244",
    textTgba: "0,0,0",
}
